import LodInfoView from "components/view/lod/lod/info";
import { lodProps } from "interface/lod";
import { useState } from "react";

const LodInfoPage = () => {
  const [info, setInfo] = useState<lodProps>({
    lodGrpNo: "",
    lodNo: "",
    lodGrdCd: "",
    lodCntyCd: "",
    lodAddr1: "",
    lodAddr2: "",
    lodAddr3: "",
    lodAddr4: "",
    lodZipc: "",
    lodTelCntyCd: "+82",
    lodTelNo: "",
    telCntyCd: "+82",
    telNo: "",
    lodEml: "",
    hpUrl: "",
    rmCnt: 0,
    manFstnm: "",
    manSurnm: "",
    manGrd: "",
    sellAmDvc: "",
    sellAmVatInYn: "N",
    resvETi: "",
  });

  const [addInfo, setAddInfo] = useState<any>();
  const [img, setImg] = useState<any>();

  const handleChange = (name: string, value: string) => {};

  const handleAddInfoChange = (name: string, value: string) => {};

  const handleSelect = (target: EventTarget & HTMLLIElement) => {};
  return (
    <LodInfoView
      info={info}
      handleAddInfoChange={handleAddInfoChange}
      handleChange={handleChange}
      handleSelect={handleSelect}
    />
  );
};

export default LodInfoPage;
